/**
 * REST error shape (43 §3.10): every non-2xx response body is `{ error: { code, message } }`.
 * `message` is for logs and developers; the client shows text keyed by `code`.
 * Codes shared with the WebSocket `ErrorCode` (43 §3.10) keep the same spelling.
 */
import { z } from 'zod';
export const API_ERROR_CODES = [
    // generic
    'bad_request', // body/query failed validation (400)
    'unauthorized', // no or expired session (401)
    'not_allowed', // signed in but forbidden, e.g. self-transfer or over the cap (403)
    'not_found', // (404)
    'conflict', // e.g. stale version (409)
    'rate_limited', // (429)
    'internal', // (500)
    // auth (98 Round 7 S-auth)
    'invalid_credentials', // generic "email or password wrong" (401)
    'under_age', // DOB under 18: rejected before any write (Q-23) (403)
    'not_invited', // email not on the tester allowlist (403)
    'email_taken', // (409)
    'banned', // (403)
    // characters
    'character_exists', // one character per account (Q-30) (409)
    'no_character', // endpoint needs a character first (409)
    // money (41 §3.3)
    'insufficient_funds', // (409)
    'recipient_not_found', // (404)
    'idempotency_key_reused', // same key, different body (422)
];
export const ApiErrorSchema = z.object({
    error: z.object({ code: z.enum(API_ERROR_CODES), message: z.string() }),
});
export function apiError(code, message) {
    return { error: { code, message } };
}
export function isApiError(body) {
    return ApiErrorSchema.safeParse(body).success;
}
